import { lazy } from 'react';

/** Загружает страницу управления кэшем */
export const CacheManagementPageAsync = lazy(() => import('./CacheManagementPage'));
